'use client';

import { useEffect, useState } from 'react';

interface SafeProvidersProps {
  children: React.ReactNode;
}

export function SafeProviders({ children }: SafeProvidersProps) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Prevent hydration mismatches by not rendering client-side content until mounted
  if (!isMounted) {
    return <div suppressHydrationWarning>{children}</div>;
  }

  return <>{children}</>;
}